import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { useUpload } from '../contexts/UploadContext';
import BatchUploader from './SharedUploadSession';

// This lives outside the routes so navigation cannot retarget an open upload.
export default function AlbumUploadButton({ user }) {
  const location = useLocation();
  const upload = useUpload();
  const [session, setSession] = useState(null);
  const albumId = location.pathname.match(/^\/albums\/([^/]+)\/?$/)?.[1];
  return <>
    {user && albumId && <button
      className="fixed z-50 p-4 text-white bg-blue-500 rounded-full shadow-lg bottom-20 right-4"
      onClick={() => {
        upload?.maximizePanel();
        setSession(current => current || { albumId });
      }}
      aria-label="Upload photos"
    ><FiPlus size={24} /></button>}
    {session && <BatchUploader albumId={session.albumId} onRequestClose={() => setSession(null)} />}
  </>;
}
